import { useEffect } from 'react';
import type {
  JobRunSearchParams,
  JobRunsResponse,
} from 'src/apis/transparency-reporting/types';
import { useAxios } from 'src/hooks/use-axios';

export const JOB_RUN_SEARCH_URL = `${PRISMA_CONFIG.transparencyReporting}/job-runs`;

type HookConfig = {
  jobRunSearchUrl: string;
  params: JobRunSearchParams;
};

type ExecuteProps = {
  url: string;
  params: JobRunSearchParams;
};

export function useJobRunSearch({ jobRunSearchUrl, params }: HookConfig) {
  const request = useAxios(
    (axios, baseConfig, { url, params }: ExecuteProps) =>
      axios.request<JobRunsResponse>({
        ...baseConfig,
        url,
        params,
      }),
    { neededOnPageLoad: false }
  );

  useEffect(() => {
    request.execute({ url: jobRunSearchUrl, params });
    // oxlint-disable-next-line exhaustive-deps
  }, [jobRunSearchUrl, params]);

  return request;
}

export type JobRunSearchRequest = ReturnType<typeof useJobRunSearch>;
